var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"pt-2"},[_c('v-flex',{style:(_vm.labelStyles)},[_c('h4',{staticClass:"text-subtitle-1 font-weight-bold"},[_vm._v(" "+_vm._s(_vm.label)+" ")])]),_c('v-flex',{staticClass:"text-break"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.value))]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }